const Influencer = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.05516 14.554L0 5.61785L2.79837 1.44629H13.1877L15.9807 5.60988L8.05516 14.554Z"
        fill="#FF3997"
      />
      <path
        d="M8.05713 14.5517L15.9807 5.60988L13.1878 1.44629H8.05713V14.5517Z"
        fill="#D6298C"
      />
      <path
        d="M0 5.61816L8.05516 14.5543L15.9583 5.63566L0 5.61816Z"
        fill="#FF5CA8"
      />
      <path
        d="M8.05713 5.62695V14.552L15.9583 5.63561L8.05713 5.62695Z"
        fill="#FF3997"
      />
      <path
        d="M8.05511 14.5544L4.74158 5.63574H11.2583L8.05511 14.5544Z"
        fill="#FF3997"
      />
      <path
        d="M11.2583 5.63535H4.74158L8.05727 1.44629L11.2583 5.63535Z"
        fill="#D6298C"
      />
      <path
        d="M0 5.61785L4.74162 5.63535L2.79837 1.44629L0 5.61785Z"
        fill="#D6298C"
      />
      <path
        d="M16 5.61785L11.2584 5.63535L13.2017 1.44629L16 5.61785Z"
        fill="#FF5CA8"
      />
      <path
        d="M8.05713 5.63477V14.5479L11.2584 5.63477H8.05713Z"
        fill="#D6298C"
      />
      <path
        d="M8.05713 1.44629V5.63501H11.2584L8.05713 1.44629Z"
        fill="#BF1B81"
      />
      <path
        d="M16 5.61785L11.2584 5.63535L13.2017 1.44629L16 5.61785Z"
        fill="#BF1B81"
      />
    </svg>
  );
};

export default Influencer;
